/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import ContestPlacesItem from './ContestPlacesItem';

const ContestPlacesList = props => (
  <div className="panel panel-default panel_padding-adp panel_fullside-xs">
    <div className="panel-heading">
      <h2 className="display-name">Призы</h2>
    </div>
    <div className="panel-body">
      <ul className="media-list media-list_hover">
        {props.contestsPlaces.map(item => (
          <ContestPlacesItem
            key={`ContestPlacesItem${item.place}`}
            place={item.place}
            contestPrize={item.contestPrize}
            contestUser={item.contestUser}
            contestsDescItemType={props.contestsDescItemType}
          />
        ))}
        {props.contestMeState &&
        props.contestsPlaces.length < props.contestMeState.place ? (
          <React.Fragment>
            <hr />
            <ContestPlacesItem
              place={props.contestMeState.place}
              contestUser={props.contestMeState.contestUser}
              contestsDescItemType={props.contestsDescItemType}
            />
          </React.Fragment>
        ) : null}
      </ul>
    </div>
  </div>
);

ContestPlacesList.defaultProps = {
  contestMeState: null
};

ContestPlacesList.propTypes = {
  // IN
  contestsDescItemType: PropTypes.shape({
    valueDesc: PropTypes.string.isRequired
  }).isRequired,
  // CONNECT STATES
  contestsPlaces: PropTypes.arrayOf(PropTypes.shape).isRequired,
  contestMeState: PropTypes.shape({
    place: PropTypes.number.isRequired,
    contestUser: PropTypes.shape.isRequired
  })
};

export default ContestPlacesList;



// WEBPACK FOOTER //
// ./src/components/Contest/layouts/ContestView/ContestPlacesList/ContestPlacesList.js